import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from "@material-ui/core/Typography";
import {Card,CardContent,Modal as MaterialModal} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import LoadingButton from '../Ui/LoadingButton'
import Dialog from '@material-ui/core/Dialog';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles(theme => ({
    modalContainer: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        // height: '100%',
        // width: '100%',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        overflow: 'scroll',
        paddingTop: 84,
        paddingBottom: 84,
    },
    modal: {
        backgroundColor: '#fff',
    }
}));

export default function GenericModal(props){

    const classes = useStyles();

    const {title,noPaddingContent,children,positiveText,negativeText,onPositive,onNegative,isLoadingData,isSubmittingData,isOpen,width,onClose,
        onConfirm,
        onNegativeConfirm,
        confirmationText,
        confirmationButtonText,
        confirmationNegativeButtonText,
        ...otherProps} = props;

    return (
        <Dialog
            maxWidth={'xl'}
            {...otherProps}
            open={isOpen}
            onBackdropClick={()=>{
                console.log('on backdrop clicked')
            }}
            disableBackdropClick={false}
            hideBackdrop={false}
            onClose={()=>{
                console.log('should close abonnetm')
                if(onNegative)
                    onNegative();
            }}
        >

            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                {children}
            </DialogContent>

            {
                !confirmationText && (
                    <DialogActions>

                        <LoadingButton isLoading={isSubmittingData} color={'success'} onClick={()=>{
                            onPositive()
                        }}><span className="text-success">{positiveText}</span></LoadingButton>
                        <Button color={'danger'} onClick={onNegative}><span className="text-danger">{negativeText}</span></Button>

                    </DialogActions>
                )
            }

            {
                confirmationText && (
                    <DialogActions>

                        <div className={'mx-1'}>
                            { confirmationText }
                        </div>
                        <LoadingButton isLoading={isSubmittingData} style={{backgroundColor: 'success', color: 'white'}} onClick={()=>{
                            onConfirm()
                        }}><span className="text-success">{confirmationButtonText}</span></LoadingButton>

                        {
                            confirmationNegativeButtonText && (
                                <Button color={'text-danger'} onClick={onNegativeConfirm}><span className="text-danger">{confirmationNegativeButtonText}</span></Button>
                            )
                        }

                    </DialogActions>
                )
            }


            {/*<div className={classes.modalContainer}>*/}

            {/*    <div style={{width: width || 600}} className={classes.modal}>*/}

            {/*        <div className="card card-custom">*/}
            {/*            <div className="card-header">*/}
            {/*                <div className="card-title">*/}
            {/*                    <h3 className="card-label">{title}</h3>*/}
            {/*                </div>*/}
            {/*                <div className="card-toolbar">*/}

            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className={`card-body ${noPaddingContent ? 'p-0' : 'px-5'} bg-white`}>*/}
            {/*                <div>*/}
            {/*                    {children}*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="card-footer d-flex justify-content-end">*/}

            {/*                <Button color={'secondary'} onClick={onNegative}>{negativeText}</Button>*/}
            {/*                <LoadingButton isLoading={isSubmittingData} color={'primary'} onClick={()=>{*/}
            {/*                    onPositive()*/}
            {/*                }}>{positiveText}</LoadingButton>*/}

            {/*            </div>*/}
            {/*        </div>*/}


            {/*    </div>*/}

            {/*</div>*/}

        </Dialog>
    );

}